import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c8161a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "mx-3 my-3"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 mb-2" }, "申請内容", -1))
const _hoisted_3 = { class: "bg-white border border-outline-color p-3 round-4" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "勤務時間", -1))
const _hoisted_6 = { class: "text-mild text-size-14" }
const _hoisted_7 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "休憩時間", -1))
const _hoisted_9 = {
  key: 0,
  class: "text-mild text-size-14"
}
const _hoisted_10 = {
  key: 1,
  class: "text-mild text-size-14"
}
const _hoisted_11 = { class: "bg-white border border-outline-color p-3 mt-3 round-4" }
const _hoisted_12 = { class: "d-flex justify-content-between" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "規定の給与", -1))
const _hoisted_14 = { class: "text-mild text-size-14" }
const _hoisted_15 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "交通費", -1))
const _hoisted_17 = { class: "text-mild text-size-14" }
const _hoisted_18 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "規定額合計", -1))
const _hoisted_20 = { class: "text-mild text-size-14 text-weight-500" }
const _hoisted_21 = { class: "d-flex justify-content-between border-top border-outline-color mt-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 mt-2" }, "変更後の給与", -1))
const _hoisted_23 = { class: "text-mild text-size-14 mt-2" }
const _hoisted_24 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "交通費", -1))
const _hoisted_26 = { class: "text-mild text-size-14" }
const _hoisted_27 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 text-weight-500" }, "変更申請額合計", -1))
const _hoisted_29 = { class: "text-mild text-size-14 text-weight-500" }
const _hoisted_30 = { class: "d-flex justify-content-between border-top border-outline-color mt-2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-16 text-weight-500 mt-2" }, "差額", -1))
const _hoisted_32 = { class: "text-blue text-size-16 text-weight-500 mt-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-12" }, "\n            報酬額が9300円以上(交通費除く)の場合、別途源泉所得税が控除されます\n          ")
], -1))
const _hoisted_34 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 mb-2" }, "申請コメント", -1))
const _hoisted_36 = { class: "bg-white border border-outline-color p-3 round-4" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 mb-2" }, "事務所コメント", -1))
const _hoisted_40 = { class: "bg-white border border-outline-color p-3 round-4" }
const _hoisted_41 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ApplicationCard = _resolveComponent("ApplicationCard")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      勤怠変更申請詳細\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (_ctx.application)
      ? (_openBlock(), _createBlock(_component_ApplicationCard, {
          key: 0,
          application: _ctx.application,
          class: "mt-3 mx-3 mb-2"
        }, null, 8, ["application"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.attendanceCorrection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.actualStartedWorkAt) + " - " + _toDisplayString(_ctx.actualFinishedWorkAt), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(),
              (_ctx.actualStartedRestAt && _ctx.actualFinishedRestAt)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.actualStartedRestAt) + " - " + _toDisplayString(_ctx.actualFinishedRestAt), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_10, "休憩無し"))
            ])
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_14, "\n            ¥\n            " + _toDisplayString(_ctx.formatNumber(_ctx.salaryPerDay)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_17, "\n            ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.variousAllowances)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_20, "\n            ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.salaryPerDay + _ctx.variousAllowances)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_23, "\n            ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.correctedSalary)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_26, "\n            ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.variousAllowances)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_29, "\n            ¥\n            " + _toDisplayString(_ctx.formatNumber(_ctx.correctedSalary + _ctx.variousAllowances)), 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_32, "\n            ¥ " + _toDisplayString(_ctx.formatNumber(_ctx.differenceSalaryPerDay)), 1)
            ]),
            _createTextVNode(),
            _hoisted_33
          ]),
          _createTextVNode(),
          (_ctx.workerComment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _hoisted_35,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("p", {
                    class: "text-size-14 comment",
                    innerHTML: _ctx.workerComment
                  }, null, 8, _hoisted_37)
                ])
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(),
          (_ctx.status !== 'submitted' && _ctx.officeComment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _hoisted_39,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("p", {
                    class: "text-size-14 comment",
                    innerHTML: _ctx.officeComment
                  }, null, 8, _hoisted_41)
                ])
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(),
          (_ctx.status === 'rejected')
            ? (_openBlock(), _createBlock(_component_AppButton, {
                key: 2,
                block: "",
                class: "mt-4",
                variant: "green",
                to: {
          name: 'AttendanceCorrection',
          params: { applicationId: _ctx.applicationId }
        }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n        再申請する\n      ")
                ], undefined, true),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}